import cloneDeep from 'lodash.clonedeep';
const updateTargetings = (banner, count) => {
  const bannerCopy = cloneDeep(banner);
  const {
    settings: {
      targetings
    }
  } = bannerCopy;
  const posn = `posn=${count + 1}`;
  const updatedTargetings = targetings ? `${targetings},${posn}` : posn;
  bannerCopy.settings.targetings = updatedTargetings;
  return bannerCopy;
};
export default updateTargetings;
//# sourceMappingURL=update-targetings.js.map